export default __webpack_public_path__ + "static/media/Group 15528.199102a7.svg";